import { Loader2 } from "lucide-react";
import { RuneLogo } from "@/components/RuneLogo";

export const FullScreenLoader = ({ label = "Loading…" }) => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-4">
    <div className="animate-pulse">
      <RuneLogo className="h-10 w-10" />
    </div>
    <div className="flex items-center gap-2 text-[color:var(--rb-text-dim)]">
      <Loader2 className="h-4 w-4 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  </div>
);
